<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t(getTitle) }}</h1>
    <!-- form  -->
    <v-card outlined class="mb-4">
      <form @keydown.enter.prevent="submit()">
        <v-card-text class="mt-5">
          <v-row class="mb-0 pb-0">
            <v-col cols="12" md="12">
              <el-text-field
                label="Institucijos pavadinimas (LT)"
                v-model="formData.title_lt"
                :disabled="modeReadonly"
                :maxlength="200"
                required
              />
            </v-col>
            <v-col cols="12" md="12">
              <el-text-field
                label="Institucijos pavadinimas (EN)"
                v-model="formData.title_en"
                :disabled="modeReadonly"
                :maxlength="200"
                required
              />
            </v-col>
            <v-col cols="12" md="12">
              <el-autocomplete
                required
                :items="classifiers['institution-group']"
                itemvalue="value"
                itemtext="text"
                :multiple="true"
                label="Institucijos grupės"
                v-model="formData.institution_groups"
              />
            </v-col>
            <v-col cols="12" md="3">
              <el-text-field
                label="Juridinio asmens kodas"
                required
                :disabled="modeReadonly"
                v-model="formData.code"
                :maxlength="20"
              />
            </v-col>

            <v-col cols="12" md="3">
              <el-date-picker
                label="Galioja nuo"
                required
                :disabled="modeReadonly"
                v-model="formData.valid_from"
              />
            </v-col>
            <v-col cols="12" md="3">
              <el-date-picker
                label="Galioja iki"
                :afterDate="formData.valid_from"
                :disabled="modeReadonly"
                v-model="formData.valid_to"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <el-button
              class="mr-1"
              color="secondary"
              icon="atšaukti"
              title="Atšaukti"
              @click.native.stop="back()"
              :loading="loading"
            />
            <el-button
              v-if="!modeReadonly"
              title="Išsaugoti"
              :loading="loading"
              @click.native="saveData()"
              color="primary"
              icon="išsaugoti"
            />
          </v-row>
        </v-card-actions>
      </form>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'

export default {
  name: 'AdminInstitutionForm',

  mixins: [userRole],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: false,
      loading: false,
      formData: {},
      classifiers: [],
    }
  },
  computed: {
    modeReadonly() {
      return false
    },
    getId() {
      return this.$route.params.id || null
    },
    getTitle() {
      if (this.getId) {
        return this.$t(`Redaguoti institucija`)
      } else {
        return this.$t(`Nauja institucija`)
      }
    },
  },
  beforeDestroy() {},
  created() {
    if (this.getId) {
      this.getData()
    } else {
      this.getClassifiers()
    }
  },
  methods: {
    back() {
      this.$router.push({ name: 'classifierInstitutions' })
    },
   async getClassifiers() {
      this.pageloading = true
      let requiredClassifiers = { classifiers: ['institution-group'] }
      await this.$axios
        .post(`classifiers`, requiredClassifiers)
        .then((res) => {
          this.classifiers = res.data.classifiers
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    async getData() {
      this.pageloading = true
      await this.getClassifiers()
      this.$axios
        .get(`institutions/${this.getId}`)
        .then((res) => {
          this.formData = res.data.institution
          this.formatSelectValue()
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    formatSelectValue() {
      this.formData.institution_groups = this.formData.institution_groups.map(
        (item) => {
          return item.id.toString()
        }
      )
    },
    saveData() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true
          let formData = this.formData
          let url = `institutions`
          this.getId && (formData.id = this.getId)
          this.$axios
            .post(url, formData)
            .then((res) => {
              this.$root.$emit('DATA_OK_CODE', '000110')
              this.back()
            })
            .catch((err) => {
             this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
